import { createApp, ref } from 'vue'
import Buefy from './vue/buefy'

import BaseIndex from './vue/BaseIndex.vue'
import i18n from './vue/vue-i18n'

import '../scss/index.scss'

class CIndex {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[Beta index online]')
      const app = document.querySelector('#vue-index')

      if (app) {
        this.app = createApp(BaseIndex)
        this.app.provide('api', app.dataset)

        Buefy(this.app)
        this.app.use(i18n)
        this.app.mount('#vue-index')
      }
    })
  }
}

const Index = new CIndex()
export default Index
